import React, { useMemo } from 'react'
import StickyHeader from 'components/elements/header'
import './index.scss'

const DEFAULT_TITLE = 'Xem trang'

export const PAGE_VIEW_CONFIGS = {
  ELECTRONIC_INSPECTION_CERTIFICATE: {
    title: 'Giấy Chứng Nhận Điện Tử',
    path: 'https://gcndangkiem.vr.org.vn/'
  },
  ELECTRONIC_TRAFFIC_POLICE: {
    title: 'Tra cứu phạt nguội',
    path: 'https://www.csgt.vn/tra-cuu-phat-nguoi'
  },
  TRAFFIC_VIOLATION_PAYMENT: {
    title: 'Thanh toán vi phạm giao thông',
    path: 'https://dichvucong.gov.vn/p/home/dvc-thanh-toan-vi-pham-giao-thong.html'
  }
}

export const buildPageViewLink = ({ path, title }) => {
  const params = new URLSearchParams()

  if (path) {
    params.set('path', path)
  }

  if (title) {
    params.set('title', title)
  }

  return `/pageView?${params.toString()}`
}

const normalizeIframePath = (path) => {
  if (!path) {
    return ''
  }

  try {
    const normalizedUrl = new URL(path, window.location.origin)

    if (!['http:', 'https:'].includes(normalizedUrl.protocol)) {
      return ''
    }

    return normalizedUrl.toString()
  } catch {
    return ''
  }
}

export default function PageView({ location }) {
  const { iframeSrc, title } = useMemo(() => {
    const params = new URLSearchParams(location.search)
    const rawPath = (params.get('path') || '').trim()
    const rawTitle = (params.get('title') || '').trim()

    return {
      iframeSrc: normalizeIframePath(rawPath),
      title: rawTitle || DEFAULT_TITLE
    }
  }, [location.search])

  return (
    <div className="PageView">
      <div className="custom-container bg-background">
        <StickyHeader showLogo={false} showArrowLeft={true} title={title} />
        {iframeSrc ? (
          <iframe
            key={iframeSrc}
            className="PageView_iframe"
            src={iframeSrc}
            title={title}
            loading="lazy"
            referrerPolicy="no-referrer"
            sandbox="allow-scripts allow-forms allow-same-origin"></iframe>
        ) : (
          <div className="PageView_empty">Liên kết không hợp lệ</div>
        )}
      </div>
    </div>
  )
}
